import styled from 'styled-components'

export const LinkListComponent = styled.div`
  .back-link {
    margin-bottom: 20px;
    display: block;
  }

  ul {
    list-style: none;
    padding: 0;
    margin-bottom: 18px;

    li + li {
      margin-top: 10px;
    }
  }

  .list-title {
    margin-bottom: 10px;
  }

  // override default link style
  .list-link {
    text-decoration: none;
    display: flex;

    &:hover {
      color: ${ (props) => props.theme.colors['standard-schwarz'] };
      text-decoration: underline;
    }

    &-icon:before {
      color: ${ (props) => props.theme.colors['icon-grau2'] };
      font-size: 18px;
    }
  }

  .link-list-label {
    line-height: 1.5em;
  }

  div.list-link {
    &:hover {
      text-decoration: none;
    }

    .list-link-icon::before {
      margin-right: 6px;
    }
  }
`
